import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: [`common`, `search`, `results`, `cart`, `docs`],
    defaultNS: `common`,

    // we init with resources
    resources: {
      en: {
        common: {
          fragnet: `Fragnet Search`,
          cookie_disclaimer: `Fragnet Search uses cookies for authentication and analytics. We use browser storage to store results and your cart.`,
          cookie_understand: `I understand`,
          login: `Login`,
          logout: `Logout`,
          profile: `Profile`,
          greeting: `Hello`,
          can_access: `You have access to Fragnet Search`,
          no_access: `You do not have access to Fragnet Search`,
          history: `History`,
          loading: `Loading...`,
          app_version: `App Version`,
          page_not_found: `The page was not found`,
          sad_squonk_alt: `Squonk crying`,
          no_server: `The server could not be found`,
          calculations: `calculations`,
          calculations_effect: `Changes will only take effect with new queries.`,
          calcs_fetch_err: `Calculations couldn't be fetched`,
          current_cart: `Current Cart`,
          no_items_selected: `There are no items selected`,
          settings: `Settings`,
          delete_local_storage: `Delete Local Storage`,
          cant_undo_1: `Your settings, history and carts will be cleared.`,
          cant_undo_2: `This can't be undone`,
          default_group_limit: `Default Group Limit`,
          reset: `Reset`,
          reset_to: `Reset to defaults`,
          favourite: `Mark as favourite`,
          selected_result: `Mark this the selected query`,
          remove_result: `Delete this query`,
          calcs_loading: `Loading calculations`,
          remove_from_cart: `Remove from cart`,
          molecules: `Molecules`,
          groups: `groups`,
        },
        search: {
          query: `Query`,
          search: `Search`,
          query_parameters: `Query Parameters`,
          hac: `Heavy Atom Count`,
          rac: `Ring Atom Count`,
          hops: `Hops`,
          groupLimit: `Group Limit`,
          start_with_example: `Start with an example`,
          no_results_404: `No results were found.`,
          no_results_500: `An internal error occurred`,
          generic_error: `An unknown error occurred`,
        },
        results: {
          add_to_cart: `Add to cart`,
          header_current_query: `Current Query`,
          header_groups: `Groups`,
          groups: `Groups`,
          filters: `Filters`,
          add_all_cart: `Add all of this group to the cart`,
          remove_all_cart: `Remove all of this group from the cart`,
          close_filter_panel: `Close filter panel`,
          no_members_left_0: `No members were left after this group was filtered.`,
          no_members_left_1: `There are `,
          no_members_left_2: ` members left in other groups.`,
          hapax_legomenon: `Only one value of this property exists in the data`,
          copy_smiles: `Copy SMILES to clipboard`,
          set_query_mol: `Use this molecule as a query`,
          no_calcs: `You have no calculations enabled`,
        },
        groupClassifications: {
          DELETION: 'Deletion',
          DELETIONS: 'Multiple deletions',
          FG_DELETION: 'FG deletion',
          FG_DELETIONS: 'FG deletions',
          RING_DELETION: 'Ring deletion',
          RING_DELETIONS: 'Ring deletions',
          ADDITION: 'Addition',
          ADDITIONS: 'Multiple additions',
          FG_ADDITION: 'FG addition',
          FG_ADDITIONS: 'FG additions',
          RING_ADDITION: 'Ring addition',
          RING_ADDITIONS: 'Ring additions',
          SUBSTITUTE_FG: 'FG substitution',
          SUBSTITUTE_LINKER: 'Linker substitution',
          SUBSTITUTE_RING: 'Ring substitution',
          ADDITION_DELETION: 'Addition/deletion',
          FG_ADDITION_DELETION: 'FG addition/deletion',
          RING_ADDITION_DELETION: 'Ring addition/deletion',
        },
        cart: {
          new_cart: `New Cart`,
          suppliers_fetch_err: `Suppliers couldn't be fetched`,
          confirm: `OK`,
          availability_err: `Some or all the availability requested couldn't be fetched`,
          suppliers: `Suppliers`,
          fetch_availability: `Fetch Availability`,
          fetch_all: `Fetch availability for all items in the cart`,
          add_all_to_list: `Add everything from the cart to the list`,
          remove_all_from_list: `Remove everything from the cart from the list`,
          delete_cart: `Delete this cart and all its contents. This can't be undone`,
          copy_list: `Copy list above to the clipboard`,
          download_list: `Download the above list as a .tsv file`,
          empty_is_cart: `This cart is empty`,
          codes: `Codes`,
          smiles_and_codes: `Smiles + Codes`,
        },
        docs: {
          docs_loading: `Loading Docs`,
        },
      },
    },
    fallbackLng: `en`,
    debug: true,

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
